import { Route, Routes } from 'react-router-dom';
import './App.css';
import ProtectedRoute from './middleware/ProtectedRoute';
import Login from './component/Login';
import AdminDashboard from './component/Admin/AdminDashboard';
import AllOrgsUsers from './component/Admin/AllOrgUsers';
import CreateUser from './component/Admin/CreateUser';
import SuperadminDashboard from './component/Superadmin/SuperadminDashboard';
import AllOrgs from './component/Superadmin/AllOrgs';
import CreateOrg from './component/Superadmin/CreateOrg';
import EditOrg from './component/Superadmin/EditOrg';
import EditAdmin from './component/Superadmin/EditAdmin';
import OrgDetails from './component/Admin/OrgDetails';
import UserDashboard from './component/Users/UserDashboard';
import Dashboard from './component/Users/Dashboard';
import SRACreation from './component/Users/Buyer/SRACreation/SRACreation';
import ViewSRA from './component/Users/ViewSRA';
import SRAUpdate from './component/Users/Buyer/SRAUpdate/SRAUpdate';
import ForgotPassword from './component/ForgotPassword';
import { useEffect } from 'react';
import ServiceOrderDashboard from './component/Users/Buyer/Dashboards/ServiceOrderDashboard';
import ViewForm from './component/Users/ViewForm';
import VendorBalanceCreation from './component/Users/Buyer/VendorBalanceCreation/VendorBalanceCreation';
import VendorBalanceUpdate from './component/Users/Buyer/VendorBalanceUpdate/VendorBalanceUpdate';
import InvoiceApprovalCreation from './component/Users/Buyer/InvoiceApprovalCreation/InvoiceApprovalCreation';
import InvoiceApprovalUpdate from './component/Users/Buyer/InvoiceApprovalUpdate/InvoiceApprovalUpdate';
import CustomerApprovalCreation from './component/Users/Buyer/CustomerApprovalCreation/CustomerApprovalCreation';
import CustomerApprovalUpdate from './component/Users/Buyer/CustomerApprovalUpdate/CustomerApprovalUpdate';
import TradeMarketingCreation from './component/Users/Buyer/TradeMarketingCreation/TradeMarketingCreation';
import TradeMarketinglUpdate from './component/Users/Buyer/TradeMarketingUpdate/TradeMarketingUpdate';
import CustomerBalanceCreation from './component/Users/Buyer/CustomerBalanceCreation/CustomerBalanceCreation';
import CustomerBalanceUpdate from './component/Users/Buyer/CustomerBalanceUpdate/CustomerBalanceUpdate';
import AdvanceGivenCreation from './component/Users/Buyer/AdvanceGivenCreation/AdvanceGivenCreation';
import AdvanceGivenUpdate from './component/Users/Buyer/AdvanceGivenUpdate/AdvanceGivenUpdate';
import DepositGivenCreation from './component/Users/Buyer/DepositGivenCreation/DepositGivenCreation';
import DepositGivenUpdate from './component/Users/Buyer/DepositGivenUpdate/DepositGivenUpdate';
import OtherCreation from './component/Users/Buyer/OtherFormCreation/OtherCreation';
import OtherUpdate from './component/Users/Buyer/OtherFormUpdate/OtherUpdate';
import CustomerDepositCreation from './component/Users/Buyer/CustomerDepositCreation/CustomerDepositCreation';
import CustomerDepositUpdate from './component/Users/Buyer/CustomerDepositUpdate/CustomerDepositUpdate';
import TenderDepositCreation from './component/Users/Buyer/TenderDepositCreation/TenderDepositCreation';
import TenderDepositUpdate from './component/Users/Buyer/TenderDepositUpdate/TenderDepositUpdate';
import VendorAdvanceUpdate from './component/Users/Buyer/VendorAdvanceUpdate/VendorAdvanceUpdate';
import InventoryCreation from './component/Users/Buyer/InventoryCreation/InventoryCreation';
import InventoryUpdate from './component/Users/Buyer/InventoryUpdate/InventoryUpdate';
import VendorApprovalUpdate from './component/Users/Buyer/VendorApprovalUpdate/VendorApprovalUpdate';
import VendorApprovalCreation from './component/Users/Buyer/VendorApprovalCreation/VendorApprovalCreation';
import VendorAdvanceCreation from './component/Users/Buyer/VendorAdvanceCreation/VendorAdvanceCreation';
import PlantDetails from './component/Admin/PlantDetails';
import AddPlant from './component/Admin/AddPlant';
import VendorList from './component/Admin/VendorList';
import AddVendor from './component/Admin/AddVendor';
import AdminControl from './component/Admin/AdminControl';
import SuperuserDashboard from './component/Users/Others/SuperuserDashboard';

function App() {
  useEffect(() => {
  const wheelHandler = (e) => {
    if (document.activeElement.matches('input[type=number]')) {
      e.preventDefault();
    }
  };

  const keyHandler = (e) => {
    if (
      document.activeElement.matches('input[type=number]') &&
      (e.key === "ArrowUp" || e.key === "ArrowDown")
    ) {
      e.preventDefault();
    }
  };

  window.addEventListener("wheel", wheelHandler, { passive: false });
  window.addEventListener("keydown", keyHandler);

  return () => {
    window.removeEventListener("wheel", wheelHandler);
    window.removeEventListener("keydown", keyHandler);
  };
}, []);
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/user-onboarding" element={<ForgotPassword />} />
        <Route element={<ProtectedRoute allowedRoles={["SUPERADMIN"]} />}>
          <Route path="/superadmin-dashboard" element={<SuperadminDashboard />}>
            <Route path="/superadmin-dashboard" element={<AllOrgs />} />
            <Route path="/superadmin-dashboard/create-org" element={<CreateOrg />} />
            <Route path="/superadmin-dashboard/:orgId" element={<EditOrg />} />
            <Route path="/superadmin-dashboard/:orgId/admin" element={<EditAdmin />} />
          </Route>
        </Route>

        <Route element={<ProtectedRoute allowedRoles={["ADMIN"]} />}>
          <Route path="/admin" element={<AdminDashboard />}>
            <Route path="/admin/org-details" element={<OrgDetails />} />
            <Route path="/admin" element={<AllOrgsUsers />} />
            <Route path="/admin/create-user" element={<CreateUser />} />
            <Route path="/admin/:orgUserId" element={<CreateUser />} />
            <Route path="/admin/plants" element={<PlantDetails />} />
            <Route path="/admin/add-plant" element={<AddPlant />} />
            <Route path="/admin/controls" element={<AdminControl />} />
            <Route path="/admin/vendors" element={<VendorList />} />
            <Route path="/admin/add-vendor" element={<AddVendor />} />
            <Route path="/admin/requests" element={<SuperuserDashboard />} />
          </Route>
        </Route>

        <Route element={<ProtectedRoute allowedRoles={["BUYER", "PURCHASE_HEAD", "TECHNICAL_HEAD", "FINANCE_HEAD", "TECHNICAL_MANAGER", "FINANCE_MANAGER", 'COO', 'CFO', 'CEO', 'CMD', "FINANCE_PROCESSOR", "SUPERUSER", "ACCOUNT_PAYABLE_TEAM"]} />}>
          <Route path="/dashboard" element={<UserDashboard />}>
            <Route path="/dashboard" element={<Dashboard />} />
            
            <Route path="/dashboard/create-service-order" element={<SRACreation />} />
            <Route path="/dashboard/create-service-order/draft/:draftSraId" element={<SRACreation />} />
            <Route path="/dashboard/edit-service-order/:sraId" element={<SRAUpdate />} />
            
            <Route path="/dashboard/create-invoice-approval" element={<InvoiceApprovalCreation />} />
            <Route path="/dashboard/create-invoice-approval/draft/:draftSraId" element={<InvoiceApprovalCreation />} />
            <Route path="/dashboard/edit-invoice-approval/:sraId" element={<InvoiceApprovalUpdate />} />
            
            <Route path="/dashboard/create-customer-approval" element={<CustomerApprovalCreation />} />
            <Route path="/dashboard/create-customer-approval/draft/:draftSraId" element={<CustomerApprovalCreation />} />
            <Route path="/dashboard/edit-customer-approval/:sraId" element={<CustomerApprovalUpdate />} />
            
            <Route path="/dashboard/create-vendor-approval" element={<VendorApprovalCreation />} />
            <Route path="/dashboard/create-vendor-approval/draft/:draftSraId" element={<VendorApprovalCreation />} />
            <Route path="/dashboard/edit-vendor-approval/:sraId" element={<VendorApprovalUpdate />} />
            
            <Route path="/dashboard/create-trade" element={<TradeMarketingCreation />} />
            <Route path="/dashboard/create-trade/draft/:draftSraId" element={<TradeMarketingCreation />} />
            <Route path="/dashboard/edit-trade/:sraId" element={<TradeMarketinglUpdate />} />
            
            <Route path="/dashboard/create-vendor-balance" element={<VendorBalanceCreation />} />
            <Route path="/dashboard/create-vendor-balance/draft/:draftSraId" element={<VendorBalanceCreation />} />
            <Route path="/dashboard/edit-vendor-balance/:sraId" element={<VendorBalanceUpdate />} />
            
            <Route path="/dashboard/create-customer-balance" element={<CustomerBalanceCreation />} />
            <Route path="/dashboard/create-customer-balance/draft/:draftSraId" element={<CustomerBalanceCreation />} />
            <Route path="/dashboard/edit-customer-balance/:sraId" element={<CustomerBalanceUpdate />} />
            
            <Route path="/dashboard/create-advance-given" element={<AdvanceGivenCreation />} />
            <Route path="/dashboard/create-advance-given/draft/:draftSraId" element={<AdvanceGivenCreation />} />
            <Route path="/dashboard/edit-advance-given/:sraId" element={<AdvanceGivenUpdate />} />
            
            <Route path="/dashboard/create-deposit-given" element={<DepositGivenCreation />} />
            <Route path="/dashboard/create-deposit-given/draft/:draftSraId" element={<DepositGivenCreation />} />
            <Route path="/dashboard/edit-deposit-given/:sraId" element={<DepositGivenUpdate />} />
            
            <Route path="/dashboard/create-other" element={<OtherCreation />} />
            <Route path="/dashboard/create-other/draft/:draftSraId" element={<OtherCreation />} />
            <Route path="/dashboard/edit-other/:sraId" element={<OtherUpdate />} />

            <Route path="/dashboard/create-customer-deposit" element={<CustomerDepositCreation />} />
            <Route path="/dashboard/create-customer-deposit/draft/:draftSraId" element={<CustomerDepositCreation />} />
            <Route path="/dashboard/edit-customer-deposit/:sraId" element={<CustomerDepositUpdate />} />

            <Route path="/dashboard/create-tender-deposit" element={<TenderDepositCreation />} />
            <Route path="/dashboard/create-tender-deposit/draft/:draftSraId" element={<TenderDepositCreation />} />
            <Route path="/dashboard/edit-tender-deposit/:sraId" element={<TenderDepositUpdate />} />

            <Route path="/dashboard/create-vendor-advance" element={<VendorAdvanceCreation />} />
            <Route path="/dashboard/create-vendor-advance/draft/:draftSraId" element={<VendorAdvanceCreation />} />
            <Route path="/dashboard/edit-vendor-advance/:sraId" element={<VendorAdvanceUpdate />} />

            <Route path="/dashboard/create-inventory" element={<InventoryCreation />} />
            <Route path="/dashboard/create-inventory/draft/:draftSraId" element={<InventoryCreation />} />
            <Route path="/dashboard/edit-inventory/:sraId" element={<InventoryUpdate />} />

            <Route path="/dashboard/:sraId" element={<ViewForm />} />

            <Route path="/dashboard/vendors" element={<VendorList />} />
            <Route path="/dashboard/add-vendor" element={<AddVendor />} />
            <Route path="/dashboard/add-vendor/:vendorCode" element={<AddVendor />} />
          </Route>
        </Route>
        </Routes>
    </div>
  );
}

export default App;
